import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=b78129b8&"
import script from "./CreateEvent.vue?vue&type=script&lang=js&"
export * from "./CreateEvent.vue?vue&type=script&lang=js&"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports